import { useCompatibility } from 'marketplace-ui-common/compatibility/hooks/useCompatibility';
import { CompatibilityModal } from 'marketplace-ui-details/compatibility/CompatibilityModal';
import LoadingWrapper from 'marketplace-ui-common/layout/components/LoadingWrapper';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * @deprecated only for use with deprecated integrationFeatures
 */
export const LegacyFeatureCompatibilityModal = ({
  appContext,
  onClose,
  integrationFeatures,
  tierGroupNames,
  trackInteraction
}) => {
  const scopeFeatures = integrationFeatures.map(feature => ({
    text: feature.headline,
    scopes: feature.hubSpotFeatures
  }));
  const {
    compatibilityRequestState,
    featuresWithTierCompatibility,
    portalTiers
  } = useCompatibility({
    appContext,
    offeringType: 'APP',
    scopeFeatures,
    tierGroupNames
  });
  return /*#__PURE__*/_jsx(LoadingWrapper, {
    requestStatus: compatibilityRequestState,
    children: /*#__PURE__*/_jsx(CompatibilityModal, {
      appContext: appContext,
      featuresWithTierCompatibility: featuresWithTierCompatibility,
      onClose: onClose,
      productType: "APP",
      portalTiers: portalTiers,
      trackInteraction: trackInteraction
    })
  });
};